import { ICarouselLayout, LayoutStyle } from 'types'
import Layout from '..'
import { LayoutHelpers } from '../../../desktopTypes'
import { useLayoutItems } from '../../../utils/layoutUtils'
import { SCarousel } from '../../scaled'
import EmptyLayout from '../EmptyLayout'

export default function CarouselLayout({
  layouts,
  keyPath,
}: Omit<ICarouselLayout, 'type'> & LayoutHelpers) {
  const items = useLayoutItems(
    layouts.map(l => ({ ...l, style: defaultStyle })),
    keyPath
  )

  if (items.length === 0) return <EmptyLayout type="carousel" />

  return (
    <SCarousel>
      {items.map(({ style, ...rest }, index) => (
        <Layout style={{ ...style, height: '100%', width: '100%' }} {...rest} key={index} />
      ))}
    </SCarousel>
  )
}

const defaultStyle: LayoutStyle = {
  padding: [40],
  grow: 1,
  borderRadius: 0,
}
